import css from 'styled-jsx/css';

const styles = css.global`.shr-btn-white {
  border: none;
  border-radius: 4px;

  background: none;
  background-color: #fff;
  color: #cc0000;

  cursor: pointer;
  text-decoration: none;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  height: 50px;
  width: 168px;
  font-size: 18px;
  letter-spacing: 0;
  padding: 0 8px;
  box-sizing: border-box;
  font-family: 'SantanderText';

  border: 1px solid #cc0000;

  transition: background-color 350ms linear;
}

.shr-btn-white.wide {
  width: 100%;
  max-width: 600%;
}

.shr-btn-white:hover {
  background-color: #fbd0d0;
}

@media (min-width: 992px) {
  .shr-btn-white {
    width: 180px;
  }

  .shr-btn-white.wide{
    max-width: 180px;
  }
}
`;

export default styles;